import SearchBox from '../../../../lib/search-box/search-box';

window.BailiffShowView = function (options) {
	const _self     = this,
		  _settings = {
			  ...{
				  mapAddresses: []
			  }, ...options
		  };

	function _init () {
		new SearchBox($('#searchBox'));
		addEvents();
	}

	window.initBailiffShowServices = function () {
		initSearchBoxServices();
		if (_settings.mapAddresses.length > 0) {
			initGoogleMap();
		}
	};

	function addEvents(){
		if ($('#js-show-search-box').length > 0) {
			$('#js-searchbox-container').slideUp(50,function(){
			});

			$('#js-show-search-box').on('click', function () {

				$('#js-searchbox-container').slideDown();
				$('#js-show-search-box').slideUp();
			});
		}
	}
	function initGoogleMap () {
		let map     = new google.maps.Map(document.getElementById('map'), {
				center: _settings.mapAddresses[0],
				maxZoom: 15,
				zoomControl: true,
				disableDefaultUI: true
			}),
			bounds  = new google.maps.LatLngBounds(),
			markers = [];


		$.each(_settings.mapAddresses, function (key, address) {
			let marker = new google.maps.Marker({
					position: address,
					animation: google.maps.Animation.DROP,
					map: map,
					visible: false
				}),
				loc    = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
			bounds.extend(loc);
			markers.push(marker);
			new google.maps.Circle({
				center: new google.maps.LatLng(marker.position.lat(), marker.position.lng()),
				radius: address.range,
				strokeColor: "#FFFFFF",
				strokeOpacity: 0.8,
				strokeWeight: 1,
				fillColor: "#ff0d00",
				fillOpacity: 0.1,
				map: map
			});
		});

		map.fitBounds(bounds);   // auto-zoom
		map.panToBounds(bounds); // auto-center
	}

	_init();
};
